import { featureKeys as dashboardFeatureKeys } from '@/api/callcenter/dashboard';
import { axios } from '@/lib/axios';
import queryClient from '@/lib/react-query';
import { ModelID } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { featurePath, ReleaseAssignmentDTO } from '.';

export type ReleaseAssignmentInput = {
  assignmentId: ModelID;
  dto: ReleaseAssignmentDTO;
};

// 204 No Content, same shape as activity -- direct axios, no envelope to
// unwrap. No skipErrorToast: a failed release should surface the global
// error toast.
export const postReleaseAssignment = async (
  assignmentId: ModelID,
  dto: ReleaseAssignmentDTO,
): Promise<void> => {
  await axios.post(`${featurePath}/${assignmentId}/release`, dto);
};

export const useReleaseAssignment = () => {
  return useMutation<void, AxiosError, ReleaseAssignmentInput>({
    mutationFn: ({ assignmentId, dto }) => postReleaseAssignment(assignmentId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dashboardFeatureKeys.all });
    },
  });
};
